import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const InfoOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" d="M12 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm0-8c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm0 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7z" />
  </SvgIcon>
);
